import { Heart, ExternalLink, Coffee, Github, BookOpen } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="py-8 px-6 bg-gradient-to-b from-transparent to-gray-100 dark:to-gray-800/50">
      <div className="max-w-7xl mx-auto text-center">
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          Created and maintained by{' '}
          <a
            href="https://telegram.me/aenzBot"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg hover:scale-105 transform"
          >
            <Coffee className="w-4 h-4" />
            Contact Developer
            <ExternalLink className="w-4 h-4" />
          </a>
        </p>
        
        <p className="mb-6 flex items-center justify-center gap-2 text-gray-700 dark:text-gray-300">
          Made with <Heart className="w-4 h-4 text-red-500 animate-pulse" fill="currentColor" /> for the community
        </p>

        <div className="space-y-4 text-gray-700 dark:text-gray-300">
          <p className="mb-4 text-sm italic">
            💡 Interested in the source code? Contact the developer via Telegram bot above.
          </p>
          
          <div className="flex items-center justify-center gap-6 flex-wrap">
            <a
              href="https://github.com/nvsupr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200 hover:scale-110 transform"
            >
              <Github className="w-4 h-4" />
              GitHub
              <ExternalLink className="w-4 h-4" />
            </a>
            
            <a
              href="https://www.web.us.kg/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-purple-200 dark:bg-purple-700 hover:bg-purple-300 dark:hover:bg-purple-600 transition-all duration-200 hover:scale-110 transform"
            >
              <BookOpen className="w-4 h-4" />
              Blog
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};